const base = import.meta.env.VITE_ADMIN_API_BASE?.replace(/\/$/, "") ?? "";

export function getAdminApiBase(): string {
  if (!base) {
    console.warn("VITE_ADMIN_API_BASE is not set; API calls may fail.");
  }
  return base;
}

/** 启动时自检：当前页 origin 是否落在白名单（仅提示，最终以服务端 CORS 为准） */
export function warnIfOriginNotAllowed(): void {
  const raw = import.meta.env.VITE_ADMIN_ALLOWED_ORIGINS ?? "";
  const allowed = raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (!allowed.length) return;
  if (!allowed.includes(window.location.origin)) {
    console.warn(
      `[admin-web] 当前 Origin ${window.location.origin} 不在 VITE_ADMIN_ALLOWED_ORIGINS 中，联调可能被后端拒绝。`
    );
  }
}
